import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { State } from 'state';
import { connect } from 'react-redux';
import { navigateAction } from 'fluxible-router';
import validators from 'app/scripts/utils/validators';
import config from 'config/config';
import LoginPageLogo from 'app/scripts/components/common/login/logo';
import DisclaimerAndRights from '../../../common/disclaimer-rights';
import TextField from '../../../common/inputs/text-field';
import { getNetwork, getSpotId, isDefaultNetwork } from '../../../../services/app-state';
import forgotPasswordAction from '../../state/actions/forget-password';
import { NetworkRequestStatus } from '../../state';

const { SUCCESS, ERROR, LOADING, NONE } = NetworkRequestStatus;

interface IProps {
  status: NetworkRequestStatus;
  forgotPassword: (props) => any;
}

interface IState {
  value: string;
  status: NetworkRequestStatus;
  message?: string;
}

const mapDispatchToProps = dispatch => ({
  forgotPassword: props => {
    dispatch(forgotPasswordAction(props));
  }
});

const mapStateToProps = (state: State) => {
  return {
    status: state.account?.forgotPassword?.status,
  };
};

class ForgotPassword extends Component<IProps, IState> {
  constructor(props, context) {
    super(props, context);
    this.state = {
      status: NONE,
      message: null,
      value: ''
    };
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    var { status } = this.props;
    if (status !== nextProps.status && nextProps.status === SUCCESS) {
      var url = null;
      var queryParams = `?email_sent=true&userVersion=1`;
      if (isDefaultNetwork()) {
        url = '/login';
      } else {
        var network = getNetwork();
        url = `/network/${network.name}`;
      }
      url += queryParams;
      this.context.executeAction(navigateAction, { url });
    }
  }
  handleEmailChange(value) {
    var status = NONE;
    var message = null;

    if (value.trim().length) {
      var isValidEmail = validators.email(value);

      if (!isValidEmail) {
        status = ERROR;
        message = 'Email address appears to be invalid';
      } else {
        status = SUCCESS;
      }
    }

    this.setState({ status, message, value });
  }
  forgotPassword() {
    var { status } = this.props;

    if (status !== LOADING) {
      let network = getNetwork();
      let spotId = getSpotId();
      let email = this.state.value;
      let url = config.api.urls.setPassword;
      if (network && network.name) {
        url += `?spot_im_network_name=${network.name}`;
      }
      this.props.forgotPassword({ email, url, networkId: network.id, spotId });
    }
  }
  navigateToLogin() {
    this.context.executeAction(navigateAction, {
      url: '/login'
    });
  }
  render() {
    var emailField = this.state;
    var { status } = this.props;
    var errorMessage = null;
    var className = 'form-wrapper';
    if (status === ERROR) {
      errorMessage = <div className="error-message">Sorry, no account exists for this email.</div>;
      className += ' has-message';
    }

    return (
      <div className="form">
        <div className={className}>
          {errorMessage}
          <div className="main-content">
            <LoginPageLogo />
            <div className="text-section">
              <span className="title">Password Reset</span>
              <p className="text">
                Enter the email address associated with your account, and we'll email you a link to
                reset your password
              </p>
            </div>
            <div className="fields">
              <div>
                <div className="input-title">Your email</div>
                <TextField
                  validation={emailField}
                  showValidationTooltip
                  onChange={this.handleEmailChange.bind(this)}
                />
              </div>
            </div>
            <button
              className="continue-button"
              onClick={this.forgotPassword.bind(this)}
              disabled={emailField.status !== SUCCESS}
            >
              {status === LOADING ? <span className="spinner" /> : 'Send Reset Link'}
            </button>
          </div>
          <DisclaimerAndRights />
        </div>
      </div>
    );
  }
}

ForgotPassword.contextTypes = {
  getStore: PropTypes.func.isRequired,
  executeAction: PropTypes.func.isRequired
};

export default connect(mapStateToProps, mapDispatchToProps)(ForgotPassword);
